function createFilter (queryString) {
  return (restaurant) => {
    return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
  }
}
export default {
  requestData (queryString, cb, data) {
    var restaurants = data
    // eslint-disable-next-line no-undef
    var results = queryString ? restaurants.filter(createFilter(queryString)) : restaurants
    // 调用 callback 返回建议列表的数据
    cb(results)
  }
}
